export default {
  thematicPagesList: []
}
